import { useServerTable } from '../../components/common/tables/useServerTable';
import { tableParams, type TableCriteria } from '../../components/common/tables/tableQuery';
import { validAccount } from './accountApi';

export function accountTableParams(criteria: TableCriteria): URLSearchParams {
  const params = tableParams(criteria);
  if (!params.has('is_archived')) params.set('is_archived', 'false');
  return params;
}
const options = {
  endpoint: 'customer-accounts',
  resource: 'Customer accounts',
  params: accountTableParams,
  validRow: validAccount,
};
export function useAccountsTable(enabled: boolean, access?: string | null) {
  return useServerTable(enabled, access, options);
}
